<template>
  <div id="allmap" class="allmap"></div>
</template>

<script>
  import BMap from 'BMap'

  export default {
    name: 'Map',
    props:['publicData'],
    data () {
      return {

      }
    },
    methods:{
      map:function(){
        var publicData = this.publicData;
        console.log(publicData);
        console.log(publicData.Addr);
        var map = new BMap.Map("allmap");
        // var point = new BMap.Point(118.072692, 24.632225);
        map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
        // map.centerAndZoom(point, 15);  // 编写自定义函数，创建标注

        map.addControl(new BMap.NavigationControl());
        map.addControl(new BMap.ScaleControl());
        map.addControl(new BMap.OverviewMapControl());
        map.addControl(new BMap.MapTypeControl());
        // map.setCurrentCity("厦门"); // 仅当设置城市信息时，MapTypeControl的切换功能才能可用
        var myGeo = new BMap.Geocoder();
        // 将地址解析结果显示在地图上,并调整地图视野
        myGeo.getPoint(publicData.Addr, function(point){
          if (point) {
            map.centerAndZoom(point, 16);
            map.addOverlay(new BMap.Marker(point));
            var opts = {
              width : 30,     // 信息窗口宽度
              height: 30,     // 信息窗口高度
              title : publicData.CompanyName,  // 信息窗口标题
            }
            var infoWindow = new BMap.InfoWindow(publicData.Addr, opts);  // 创建信息窗口对象
            map.openInfoWindow(infoWindow, map.getCenter());      // 打开信息窗口
          }else{
            console.log("地址没有解析到结果!");
          }
        }, "厦门市");
      }
    },
    mounted(){
      this.map()
    },
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {font-weight: normal}
  ul {list-style-type: none;padding: 0}
  li {display: inline-block;margin: 0 10px;}
  a {color: #42b983;}


  #allmap{height: 494px;overflow: hidden;width: 702px}






</style>



// WEBPACK FOOTER //
// src/components/Map/Map.vue